import { render, staticRenderFns } from "./SmoothrPay.vue?vue&type=template&id=c6ffa6c4"
import script from "./SmoothrPay.vue?vue&type=script&lang=ts"
export * from "./SmoothrPay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports